import { render, staticRenderFns } from "./RendGenericReturns.vue?vue&type=template&id=0f995478&"
import script from "./RendGenericReturns.vue?vue&type=script&lang=js&"
export * from "./RendGenericReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports